// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';

// context
import { useAuth } from '@/auth/AuthContext';

// config
import projectConfig from '@/projectConfig';

// project imports
import Profile from './Profile';
import Notification from './Notification';
import Basket from './Basket';
import MobileSection from './MobileSection';


// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const { isVerified } = useAuth();

  const widthBox = !isVerified ? '4vw' : '6vw'
  return (
    <>
      <Box 
        sx={{
          ml: 'auto',
          display: 'flex',
          width: downLG ? '15vw' : widthBox
        }}
      >
        {isVerified && projectConfig.payment ? <Basket /> : null}
        <Notification/>
        {!downLG && <Profile />}
      </Box>
      {downLG && <MobileSection />}
    </>
  );
}
